import React from "react";
import { useTranslation } from "react-i18next";
import Offline from "../../assets/images/icons/Offline";

const OfflineComponent = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div>
        <h3 className="text-primary text-center mt-5">
          {t("GENERAL.YOU_ARE_OFFLINE")}
        </h3>
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: "100%", marginTop: "100px" }}
        >
          <div>
            <Offline />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfflineComponent;
